module.exports = __webpack_public_path__ + "img/Flag_of_Slovakia.b0fbf30f.svg";